import { StrapiStore } from "~/shared-types";
import { StoreImage } from "../products/[productId]/StoreImage";
import { StoreAddress } from "../products/[productId]/StoreAddress";
import { StoreContact } from "../products/[productId]/StoreContact";
import { StoreOpeningHours } from "../products/[productId]/StoreOpeningHours";
import { StoreSocialLinks } from "~/components/StoreSocialLinks";
import { StoreFreeDelivery } from "../products/[productId]/StoreFreeDelivery";
import { StoreOtherStores } from "../products/[productId]/StoreOtherStores";
import classNames from "classnames";

type Props = {
  store: StrapiStore;
  className?: string;
};

export const StoreInfoCard = ({ store, className }: Props) => {
  return (
    <div className={classNames(
      "bg-secondary-100 w-full min-w-[320px] max-w-[600px] rounded-lg p-6 flex flex-col",
      className
    )}>
      <StoreImage className="mx-auto mb-6" store={store} />
      <StoreAddress className="pb-4 mb-4 border-b border-secondary-200" store={store} />
      <StoreOpeningHours className="pb-4 mb-4 border-b border-secondary-200" store={store} />
      <StoreContact className="pb-4 mb-4 border-b border-secondary-200" store={store} />
      <StoreSocialLinks className="pb-4 mb-4 border-b border-secondary-200" store={store} />
      <StoreFreeDelivery className="mx-auto" store={store} />
      <StoreOtherStores className="border-t border-secondary-200 mt-4 pt-4" store={store} />
    </div>
  );
};
